import {createSlice} from "@reduxjs/toolkit";
import {DOMAIN_APPROVAL} from "src/constants";

const initialState = {
    order: {},
    product: "",
    provider: "",
    presetCsr: "",
    csr: "",
    decodedCsr: {},
    webserver: "",
    dcv: "",
    approvers: [],
    uniqueId: "",
    organization: {},
    adminContact: {},
    dnsRecords: {},
    key: ""
};

const slice = createSlice({
    name: "certificate",
    initialState,
    reducers: {
        reset(state) {
            state.order = initialState.order;
            state.product = initialState.product;
            state.provider = initialState.provider;
            state.presetCsr = initialState.presetCsr;
            state.csr = initialState.csr;
            state.decodedCsr = initialState.decodedCsr;
            state.webserver = initialState.webserver;
            state.dcv = initialState.dcv;
            state.approvers = initialState.approvers;
            state.uniqueId = initialState.uniqueId;
            state.organization = initialState.organization;
            state.adminContact = initialState.adminContact;
            state.dnsRecords = initialState.dnsRecords;
            state.key = initialState.key;
        },
        init(state, action) {
            const {order, product, provider, csr} = action.payload;
            state.order = order;
            state.product = product;
            state.provider = provider;
            state.presetCsr = csr;
        },
        setCsr(state, action) {
            const {csr, decodedCsr, key} = action.payload;
            state.csr = csr;
            state.key = key;
            state.decodedCsr = decodedCsr;
        },
        setWebserver(state, action) {
            const {webserver} = action.payload;
            state.webserver = webserver;
        },
        setEmailValidation(state, action) {
            const {dcv, approvers} = action.payload;
            state.dcv = dcv;
            state.approvers = approvers;
        },
        setDnsValidation(state, action) {
            const {dcv, uniqueId, dnsRecords} = action.payload;
            state.dcv = dcv;
            state.uniqueId = uniqueId;
            state.dnsRecords = dnsRecords;
        },
        resetDcv(state) {
            state.dcv = initialState.dcv;
            state.approvers = initialState.approvers;
            state.uniqueId = initialState.uniqueId;
            state.dnsRecords = initialState.dnsRecords;
        },
        setOrganization(state, action) {
            const {organization} = action.payload;
            state.organization = organization;
        },
        setAdminContact(state, action) {
            const {adminContact} = action.payload;
            state.adminContact = adminContact;
        }
    }
});

export const reducer = slice.reducer;

export const init = (order, product, provider, csr) => dispatch => {
    dispatch(slice.actions.reset());
    dispatch(slice.actions.init({order, product, provider, csr}));
};

export const reset = () => dispatch => {
    dispatch(slice.actions.reset());
};

export const setCsr = (csr, decodedCsr, key) => dispatch => {
    dispatch(slice.actions.setCsr({csr, decodedCsr, key}));
};

export const setWebserver = webserver => dispatch => {
    dispatch(slice.actions.setWebserver({webserver}));
};

export const setEmailValidation = approvers => dispatch => {
    dispatch(slice.actions.setEmailValidation({dcv: DOMAIN_APPROVAL.email.key, approvers}));
};

export const setDnsValidation = (uniqueId, dnsRecords) => dispatch => {
    dispatch(slice.actions.setDnsValidation({dcv: DOMAIN_APPROVAL.dns.key, uniqueId, dnsRecords}));
};

export const setDnsAutoValidation = () => dispatch => {
    dispatch(slice.actions.setDnsValidation({dcv: DOMAIN_APPROVAL.dnsauto.key}));
};

export const resetDcv = () => dispatch => {
    dispatch(slice.actions.resetDcv());
};

export const setOrganization = organization => dispatch => {
    dispatch(slice.actions.setOrganization({organization}));
};

export const setAdminContact = adminContact => dispatch => {
    dispatch(slice.actions.setAdminContact({adminContact}));
};
